import { IWorkOrderByCollectionId, IWorkOrderServiceByCollectionId } from "../common/data/dtos/work-order-by-collection-id";

/**
 * Aggregates all evidences from an array of work orders into a single
 * flat collection, preserving work-order input order.
 *
 * @param workOrders - Array of work orders with evidences
 * @returns Flat array of all evidences in work-order sequence order
 *
 * Examples:
 *   WO1 with 3 evidences, WO2 with 2 evidences → [e1, e2, e3, e4, e5]
 *   WO1 with 0 evidences, WO2 with 2 evidences → [e1, e2]
 */
export function aggregateExecutedServices(
    workOrders: IWorkOrderByCollectionId[],
): IWorkOrderServiceByCollectionId[] {
    const servicesMap = new Map<string, IWorkOrderServiceByCollectionId>();

    for (const workOrder of workOrders) {
        // Garante que a lista de serviços exista para não quebrar o código
        if (!workOrder.workOrderServices) continue;

        for (const workOrderService of workOrder.workOrderServices) {
            // Cria uma chave composta combinando o ID do serviço e o Preço cobrado
            const compositeKey = `${workOrderService.serviceId}-${workOrderService.price}`;
            
            // Se essa combinação de Serviço + Preço já foi adicionada, o .set() apenas ignora/sobrescreve
            servicesMap.set(compositeKey, workOrderService);
        }
    }

    // Retorna apenas os serviços únicos, gerando a quantidade exata de colunas necessárias
    return Array.from(servicesMap.values());
}